import types from "./actionTypes";
import { dealWithSections } from '../../undoredo/actions'
import { getSections } from './selectors';
import { arrayMove } from '../../../services/builder/util.js'

export const addSection = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithSections(payload, 'add'))

	dispatch({
		type: types.ADD_SECTION,
		payload,
	})
};



export const editSection = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithSections(payload, 'edit'))

	dispatch({
		type: types.EDIT_SECTION,
		payload,
	})
};


export const deleteSection = (payload) => ({
	type: types.DELETE_SECTION,
	payload,
})

export const updateFullSections = (sections) => ({
	type: types.UPDATE_FULL_SECTIONS,
	payload: sections
})


export const moveOneSectionUpDown = (sectionID, direction) => (dispatch, getState) => {
	let sections = getSections(getState());
	let currentSection = sections.find( section => section.id == sectionID );

	let ownSections = sections.filter( section => section.parent[0].id == currentSection.parent[0].id );
	let otherSections = sections.filter( section => section.parent[0].id != currentSection.parent[0].id );

	let currentIndex = ownSections.findIndex( section => section.id == sectionID );
	let newSections = arrayMove(ownSections,currentIndex, direction == 'up' ? currentIndex-1 : currentIndex+1);

	dispatch(dealWithSections({
		orginalOrder: sections,
		afterReorder: [...otherSections, ...newSections]
	}, 'reorder'));

	dispatch({
		type: types.UPDATE_REORDERED_SECTIONS,
		payload: [...otherSections, ...newSections]
	})

}

export const replaceFullSections = (sections) => ({
	type: types.UPDATE_REORDERED_SECTIONS,
	payload: sections
})